import './utils/date'

import App from './App'
// register modal component
import VModal from 'vue-js-modal'
import VeeValidate from 'vee-validate'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import apiService from './services/api.service'
import config from './config'
import firebaseService from './services/firebase.service';
import router from './router'
import { store } from './store/store';

import { Fragment } from 'vue-frag';
Vue.component('Fragment', Fragment);

Vue.use(VModal)
Vue.use(VeeValidate)

// Handle all Vue errors
Vue.config.errorHandler = (error) => {
  console.log(error);
}


const TOKEN_EXPIRATION_CHECK_INTERVAL = 5 * 60 * 1000; // 1min in milliseconds

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})

VeeValidate.Validator.extend('afterNow', {
  getMessage: field => `The ${field} must be in the future.`,
  validate: value => {
    const valueTime = new Date(value).getTime();
    return valueTime > Date.now();
  }
});

VeeValidate.Validator.extend('validDate', {
  getMessage: field => `The ${field} must be a valid date.`,
  validate: value => {
    const date = new Date(value);
    return !Number.isNaN(date.getTime());
  }
});

// global functions
window.confirmDeleteRFQ = (combinedId) => {
  console.log("confirmDeleteRFQ: " + combinedId);
  sessionStorage.deleteRFQID = combinedId.split(".")[0];
  sessionStorage.refresh = "true";
  console.log("delete id: " + sessionStorage.deleteRFQID);

  let msg;
  if(location.hash && location.hash.indexOf("shipment") >=0) {
    msg = "Are you sure you want to delete the RFQ related to this shipment?";
  } else {
    msg = "Are you sure you want to delete this RFQ?";
  }

  if (confirm(msg)) {
    console.log("You deleted");
    deleteRFQ(sessionStorage.deleteRFQID);
    // location.reload(true);
  } else {
    console.log("You cancelled");
  } 
}

window.deleteRFQ = (rfqId) => {
  console.log("deleteRFQ: " + rfqId);
  apiService.post('/rfq/delete/' + rfqId)
  .then(function (response) {
    location.reload(true);
  })
  .catch(function (error) {
    console.log(error);
  })
}

setInterval(() => firebaseService.checkTokenExpiration(), TOKEN_EXPIRATION_CHECK_INTERVAL); 


// WEBPACK FOOTER //
// ./src/main.js